import { LOCALES } from 'i18n/locales';

export const isolatedViewIntl = {
    [LOCALES.ENGLISH]: {
        'isolatedView.alert': '<strong>Filtered view: {assetOwner} {type}assets only{sectorSpecific}</strong>{br}Assets from other providers have been hidden.',
        'isolatedView.notification.label': 'Isolated views',
        'isolatedView.electricitySymbology': 'voltage colour coding applied',
        'isolatedView.gasSymbology': 'network symbology applied'
    },
    [LOCALES.WELSH]: {
        'isolatedView.alert': '<strong>[Filtered view: {assetOwner} {type}assets only{sectorSpecific}]</strong>{br}[Assets from other providers have been hidden.]',
        'isolatedView.notification.label': 'Golygon ynysig',
        'isolatedView.electricitySymbology': '[voltage colour coding applied]',
        'isolatedView.gasSymbology': '[network symbology applied]'
    }
};
